import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    resources: [
      { name: 'Business Regulations', path: '/regulations' },
      { name: 'Funding Options', path: '/resources/small-business-loans' },
      { name: 'Business Templates', path: '/resources/business-plan-template' },
    ],
    learn: [
      { name: 'Step-by-Step Guides', path: '/guides' },
      { name: 'UTEP Business Programs', path: '/guides/utep' },
      { name: 'Market Research Tools', path: '/resources/market-research-tools' },
    ],
    connect: [
      { name: 'Networking Events', path: '/networking' },
      { name: 'Business Organizations', path: '/networking' },
      { name: 'Contact Us', path: '/contact' },
    ],
    about: [
      { name: 'El Paso Demographics', path: '/demographics' },
      { name: 'Border Economy', path: '/demographics/border-economy' },
      { name: 'Contact', path: '/contact' },
    ],
  };

  return (
    <footer className="bg-[#1B3A3A] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 400">
          <path
            d="M0 200 Q 300 150 600 200 T 1200 200"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-6" aria-label="El Paso Business - Home">
              <img 
                src="https://public.readdy.ai/ai/img_res/ec679b4d-c65e-4fa2-b265-b3c4a68e73fd.png" 
                alt="El Paso Business Logo" 
                className="h-10 w-auto"
              />
            </Link>
            <h3 className="text-2xl font-serif mb-4 leading-tight">
              Stay Connected to<br />El Paso's Business Community
            </h3>
            <div className="flex items-center space-x-2">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-1 px-4 py-3 bg-transparent border border-white/30 rounded-lg text-white placeholder-white/60 focus:outline-none focus:border-white/60 text-sm"
                aria-label="Email address for newsletter"
              />
              <button 
                className="w-12 h-12 bg-[#D2691E] rounded-full flex items-center justify-center hover:bg-[#B8571A] transition-colors cursor-pointer"
                aria-label="Subscribe to newsletter"
              >
                <i className="ri-notification-3-line text-xl"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-base">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                    aria-label={`Navigate to ${link.name}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-base">Learn</h4>
            <ul className="space-y-3">
              {footerLinks.learn.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                    aria-label={`Navigate to ${link.name}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-base">Connect</h4>
            <ul className="space-y-3">
              {footerLinks.connect.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                    aria-label={`Navigate to ${link.name}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-sm text-white/70">
            © 2025 ElPasoTexasBusiness.com. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Website Builder</a>
          </p>

          <div className="flex items-center space-x-6 text-sm text-white/70">
            <Link to="/contact" className="hover:text-white transition-colors cursor-pointer" aria-label="View Privacy Policy">
              Privacy Policy
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors cursor-pointer" aria-label="View Terms of Service">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}